const WorkExperience = [
    {
        id: 1,
        title: "PHP (Laravel) Developer",
        company: "Atenas Code",
        yearsActive: "Jan 2026 - Present",
        information: [
            "Developed and maintained features for a cab booking platform DriveMond using JavaScript, Node.js, and PHP (Laravel), collaborating closely with Flutter developers to ensure seamless app integration.",
            "Built scalable APIs for booking, authentication, and real-time updates while optimizing backend systems and databases for high performance and reliability.",
            "Enhanced front-end performance and independently delivered end-to-end freelance solutions using Laravel, Node.js, Tailwind CSS, and MySQL."
        ],
    },
    {
        id: 2,
        title: "AI Trainer & Assurance Contributor",
        company: "Turing",
        yearsActive: "Oct 2025 - Jan 2026",
        information: [
            "Trained and evaluated AI/LLM models, improving response accuracy through data annotation, prompt engineering, and quality assurance.",
            "Collaborated with global teams to refine AI systems using structured feedback while consistently performing as a strong team contributor."
        ],
    },
    {
        id: 3,
        title: "Software Developer",
        company: "Teamwork Info Solutions PVT. LTD.",
        yearsActive: "May 2024 - Oct 2025",
        information: [
            "Built and worked on full-stack web applications using JavaScript, React.js, Node.js, and MongoDB, improving performance and user experience while working effectively in a team.",
            "Developed REST APIs, handled authentication, optimized database performance, and built a real-time Drive-Thru Ordering System to improve overall efficiency and speed."
        ],
    },
    {
        id: 4,
        title: "IT Technician",
        company: "Personiv (an Eclerx Company)",
        yearsActive: "Jan 2023 - Feb 2024",
        information: [
            "Provided L1 support for hardware, software, and network issues, ensuring minimal downtime and efficient ticket resolution.",
            "Monitored system performance, troubleshot connectivity issues, and escalated complex cases to L2 teams to maintain reliability."
        ],
    }
];

export default WorkExperience;
